<template>
  <section class="slopePage">
    <Header />
    <loading :active.sync="isLoading"
             :can-cancel="false"
             color="#E30713"
             :height = 145
             :width = 145
             :opacity = 1
             backgroundColor="#eeeeee"
             :z-index = 3
             :is-full-page="fullPage"
             ></loading>
    <div class="container">
      <div class="row">
        <div class="slopePage__title" ref="title">
          Результаты расчета
        </div>
      </div>
      <div class="slopePage__pane" ref="toPdf">
        <div class="slopePage__pane-item">
          <div class="slopePage__pane-item--number">
            {{ slopesCount }}
          </div>
          <div class="slopePage__pane-item--text">
            {{ word }}
          </div>
        </div>
        <div class="slopePage__pane-item">
          <div class="slopePage__pane-item--number">
            {{totalSquare}} м<sup>2</sup>
          </div>
          <div class="slopePage__pane-item--text">
            Площадь всех участков
          </div>
        </div>
        <div class="slopePage__pane-item">
          <div class="slopePage__pane-item--number">
            {{totalVolume}} м<sup>3</sup>
          </div>
          <div class="slopePage__pane-item--text">
            Общий объем всех уклонов
          </div>
        </div>
      </div>

    </div>
    <ResultNav />
    <ResultMaterialsComputation/>
    <ResultUsedMaterials />
    <ResultFastener :fasteners="totalFasteners" :pdfStart="this.pdfStart"
                    :isFastenersNeed="isFastenersNeed"/>
    <ResultAddons :albums="albums" ref="resultAddons"/>
    <ResultPlugins ref="resultPlugins"/>
    <Prefooter @savePdf="savePdf()" @saveXls="saveXls()"/>
    <Footer ref="footer"/>
  </section>
</template>

<script>
import { saveAs } from 'file-saver';
import { mapState, mapMutations } from 'vuex';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import { isSafari } from '@/utils/utils';
import ResultNav from '../components/result/ResultNav.vue';
import ResultMaterialsComputation from '../components/result/ResultMaterialsComputation.vue';
import ResultUsedMaterials from '../components/result/ResultUsedMaterials.vue';
import ResultFastener from '../components/result/ResultFastener.vue';
import ResultAddons from '../components/result/ResultAddons.vue';
import ResultPlugins from '../components/result/ResultPlugins.vue';
import Prefooter from '../components/Prefooter.vue';
import Footer from '../components/Footer.vue';
import Header from '../components/Header.vue';

export default {
  data() {
    return {
      fullPage: true,
      isLoading: false,
      computation: [],
      sections: [],
      pdfStart: false,
      albums: [],
      totalSquare: '',
      totalVolume: '',
      totalFasteners: [],
      isFastenersNeed: true,
    };
  },
  components: {
    ResultNav,
    ResultMaterialsComputation,
    ResultUsedMaterials,
    ResultFastener,
    ResultAddons,
    ResultPlugins,
    Prefooter,
    Footer,
    Header,
    Loading,
  },
  methods: {
    ...mapMutations({
      FILTER_CATEGORIES_BY_CATEGORY: 'FILTER_CATEGORIES_BY_CATEGORY',
      FILTER_MATERIALS_BY_CATEGORY: 'FILTER_MATERIALS_BY_CATEGORY',
      UPDATE_CATEGORY: 'UPDATE_CATEGORY',
    }),
    savePdf() {
      this.isLoading = true;
      const baseUrl = (process.env.NODE_ENV === 'development') ? 'https://tn-calc.industrialmedia.com.ua/action/' : `${window.location.origin}/`;
      const string = new URLSearchParams();
      string.append('type', 'pdf_total');
      const postData = {};
      const postDataHeader = {};
      const postDataFront = {};
      postDataFront.userInfo = this.userInfo;
      postDataFront.year = new Date().getFullYear();
      postDataHeader.count = this.slopesCount;
      postDataHeader.countWord = this.word;
      postDataHeader.square = this.totalSquare;
      postDataHeader.volume = this.totalVolume;
      postDataHeader.link = this.userInfo.link;
      postData.header = postDataHeader;
      postData.firstPage = postDataFront;
      postData.materials = this.computationPdf;
      postData.albums = this.albums;
      postData.fasteners = this.totalFasteners;
      // console.log(postData);
      string.append('data', JSON.stringify(postData));
      axios.post(`${baseUrl}service_api/pdf`, string, {
        responseType: 'blob', // Force to receive data in a Blob Format
      })
        .then((response) => {
          console.log(response.data);
          // Create a Blob from the PDF Stream
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' },
          );
          // Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          this.isLoading = false;
          if (this.isSafari) {
            const fileName = 'Общий расчет.pdf';
            saveAs(file, fileName);
          } else {
            window.open(fileURL);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveXls() {
      this.isLoading = true;
      const fileName = 'Общий расчет.xlsx';
      const baseUrl = (process.env.NODE_ENV === 'development') ? 'https://tn-calc.industrialmedia.com.ua/action/' : `${window.location.origin}/`;
      const string = new URLSearchParams();
      const postData = {};
      postData.materials = this.computationPdf;
      postData.fasteners = this.totalFasteners;
      postData.page = 'total';
      string.append('data', JSON.stringify(postData));
      axios.post(`${baseUrl}service_api/excel`, string, {
        responseType: 'blob', // Force to receive data in a Blob Format
      })
        .then((response) => {
          // Create a Blob from the PDF Stream
          const file = new Blob(
            [response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
          );
          // Build a URL from the file
          // const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          this.isLoading = false;
          saveAs(file, fileName);
          // window.open(fileURL);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
  },
  async mounted() {
    // this.FILTER_CATEGORIES_BY_CATEGORY(3);
    // this.FILTER_MATERIALS_BY_CATEGORY(3);
    const baseUrl = (process.env.NODE_ENV === 'development') ? 'https://tn-calc.industrialmedia.com.ua/action/' : `${window.location.origin}/`;
    const hash = new URLSearchParams();
    const urlQuery = this.$route.query.object;
    // console.log(urlQuery);
    hash.append('data', urlQuery);
    if (typeof (urlQuery) !== 'undefined') {
      this.isLoading = true;
      await this.$store.dispatch('fetchMaterials');
      // await this.$store.dispatch('qwe');
      await axios.post(`${baseUrl}service_api/results_get`, hash)
        .then((response) => {
          // console.log(response);
          this.$store.commit('replaceAllSlopes', JSON.parse(response.data.data));
          this.$store.commit('updateResult', JSON.parse(response.data.result));
          this.totalVolume = JSON.parse(response.data.result).totalInfo.total_volume;
          this.totalSquare = JSON.parse(response.data.result).totalInfo.total_square;
          if (JSON.parse(response.data.result).fasteners.length !== 0) {
            this.totalFasteners = JSON.parse(response.data.result).fasteners;
          } else {
            this.isFastenersNeed = false;
          }
          this.albums = JSON.parse(response.data.result).totalInfo.albums;
          if (Object.prototype.hasOwnProperty.call(response.data, 'category')) {
            // console.log(parseInt(response.data.category, 10));
            this.$session.set('category', parseInt(response.data.category, 10));
            this.UPDATE_CATEGORY(parseInt(response.data.category, 10));
            // setTimeout(() => {
            //   this.FILTER_CATEGORIES_BY_CATEGORY(parseInt(response.data.category, 10));
            //   this.FILTER_MATERIALS_BY_CATEGORY(parseInt(response.data.category, 10));
            // }, 500);
          } else {
            this.$session.destroy();
          }
        })
        .catch((error) => {
          console.log(error);
          // error.response.status === 404 ? this.$router.push('/') : console.log('zdrasti');
          this.$router.push('/404');
        });
      await this.$store.dispatch('materialsPostProcessing');
      await this.$router.push('/result');
      this.isLoading = false;
    } else {
      if (this.allSlopes[0].material === '') {
        this.$router.push('/');
      } else {
        this.isLoading = true;
        const postData = new URLSearchParams();
        postData.append('data', JSON.stringify(this.allSlopes));
        axios.post(`${baseUrl}service_api/calculate`, postData)
          .then((response) => {
            // console.log(response.data);
            this.$store.commit('updateResult', response.data);
            this.totalVolume = response.data.totalInfo.total_volume;
            this.totalSquare = response.data.totalInfo.total_square;
            if (response.data.fasteners.length !== 0) {
              this.totalFasteners = response.data.fasteners;
            } else {
              this.isFastenersNeed = false;
            }
            this.albums = response.data.totalInfo.albums;
            // this.computation = response.data.total;
            // this.sections = response.data.sections;
            this.isLoading = false;
          });
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    isSafari() {
      return isSafari();
    },
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    slopesCount() {
      // return this.allSlopes.length;
      let total = 0;
      for (let i = 0; i < this.allSlopes.length; i += 1) {
        total += this.allSlopes[i].slopeCount;
      }
      return total;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
    word() {
      const cases = [2, 0, 1, 1, 1, 2];
      const words = ['участок', 'участка', 'участков'];
      return words[(this.slopesCount % 100 > 4
                      && this.slopesCount % 100 < 20) ? 2
        : cases[(this.slopesCount % 10 < 5)
          ? this.slopesCount % 10 : 5]];
    },
    result() {
      return this.$store.getters.getResult;
    },
    computationPdf() {
      return this.result.total;
    },
  },
};

</script>

<style lang="sass" scoped>
.slopePage
  overflow: hidden
  &.pb-40
    padding-bottom: rem(40)
  &__title
    +media((padding: (320: rem(32) 0 rem(27) rem(24), 992: rem(70) 0 rem(36))))
    // font-weight: 600
  &__pane
    display: grid
    +media((grid-template-columns: (320: 1fr, 650: 1fr 2fr 2fr, 768: 2fr 4fr 7fr)))
    +media((margin: (320: 0 rem(9), 992: 0 rem(-15))))
    +media((padding: (320: rem(23) rem(26) rem(31), 768: rem(34) 0)))
    &-item
      color: $black
      display: flex
      flex-direction: column
      justify-content: center
      align-items: flex-start
      &:first-of-type
        +media((padding-left: (320: 0, 768: rem(30))))
      &:nth-child(2)
        +media((padding-left: (320: 0, 768: rem(40))))
      &--number
        font-style: normal
        font-weight: bold
        padding-bottom: rem(4)
        +media((font-size: (320: rem(28), 768: rem(32), 992: rem(36))))
        +media((line-height: (320: rem(34), 768: rem(40), 992: rem(44))))
        sup
          +media((font-size: (320: rem(14), 768: rem(20))))
      &--text
        font-style: normal
        font-weight: 500
        font-size: rem(14)
        line-height: rem(18)
        +media((padding-bottom: (320: rem(22), 650: 0)))
</style>
